import MobileAPIAdapter from './adapters/mobile-api-v1'
import { IAPIAdapter } from './interfaces'

const publicApi: IAPIAdapter = new MobileAPIAdapter()

export default publicApi
